import { render, staticRenderFns } from "./TX01.vue?vue&type=template&id=eaf337cc&"
import script from "./TX01.vue?vue&type=script&lang=js&"
export * from "./TX01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports